module.exports = __webpack_public_path__ + "fonts/6a410a006d1b17d64816920c22360aee.svg";